import { render, staticRenderFns } from "./BusbarModulePage.vue?vue&type=template&id=6ec96d18"
import script from "./BusbarModulePage.vue?vue&type=script&lang=js"
export * from "./BusbarModulePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports